import Vue from 'vue'
import Vuex from 'vuex'
import { login, getInfo } from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

Vue.use(Vuex)

const state = {
  token: getToken(),
  userInfo: {},
  roles: [],
  perms: [],
  deptLeaderDeptIds: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_PERMS: (state, perms) => {
    state.perms = perms
  },
  SET_DEPT_LEADER_IDS: (state, ids) => {
    state.deptLeaderDeptIds = ids
  }
}

const actions = {
  Login({ commit }, userInfo) {
    const { username, password, code, uuid } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password, code: code, uuid: uuid }).then(res => {
        setToken(res.data.token)
        commit('SET_TOKEN', res.data.token)
        commit('SET_USER_INFO', res.data.userInfo)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  GetInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(res => {
        const data = res.data
        commit('SET_ROLES', data.roles || [])
        commit('SET_PERMS', data.perms || [])
        commit('SET_DEPT_LEADER_IDS', data.deptLeaderDeptIds || [])
        commit('SET_USER_INFO', data.user)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  Logout({ commit }) {
    return new Promise((resolve) => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      commit('SET_PERMS', [])
      commit('SET_DEPT_LEADER_IDS', [])
      commit('SET_USER_INFO', {})
      removeToken()
      resolve()
    })
  }
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  roles: state => state.roles,
  perms: state => state.perms,
  deptLeaderDeptIds: state => state.deptLeaderDeptIds
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})
